import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chRejectPatientAsPotentialDuplicateMutation as ChRejectPatientAsPotentialDuplicateMutationType } from "@/modules/patients/services/ch/__generated__/chRejectPatientAsPotentialDuplicateMutation.graphql"
import { chRejectPatientAsPotentialDuplicateMutation as chMutation } from "@/modules/patients/services/ch/chRejectPatientAsPotentialDuplicateMutation"
import { deRejectPatientAsPotentialDuplicateMutation as DeRejectPatientAsPotentialDuplicateMutationType } from "@/modules/patients/services/de/__generated__/deRejectPatientAsPotentialDuplicateMutation.graphql"
import { deRejectPatientAsPotentialDuplicateMutation as deMutation } from "@/modules/patients/services/de/deRejectPatientAsPotentialDuplicateMutation"

const useRejectPatientAsPotentialDuplicateMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  return useMutationWithErrorDialog<
    ChRejectPatientAsPotentialDuplicateMutationType & DeRejectPatientAsPotentialDuplicateMutationType
  >(mutation)
}

export { useRejectPatientAsPotentialDuplicateMutation }
